import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInstallPrompt } from '@hooks/useInstallPrompt';
import { Button, ButtonMode } from '@components/atoms/Button';
import styles from './InstallPWAPrompt.module.css';

export const InstallPWAPrompt = () => {
    const { t } = useTranslation();
    const { isInstallable, isIOSDevice, promptInstall, dismissPrompt } = useInstallPrompt();

    if (!isInstallable) {
        return null;
    }

    const handleInstall = async () => {
        await promptInstall();
    };

    if (isIOSDevice) {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.textContent}>
                        <strong className={styles.title}>{t('install-prompt.title')}</strong>
                        <span className={styles.description}>
                            {t('install-prompt.ios-description-prefix')}{' '}
                            <span className={styles.shareIcon}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .9 2 2z" />
                                </svg>
                            </span>{' '}
                            {t('install-prompt.ios-description-suffix')}
                        </span>
                    </div>
                    <div className={styles.actions}>
                        <Button
                            label={t('install-prompt.close-button')}
                            mode={ButtonMode.primary}
                            onClick={dismissPrompt}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.textContent}>
                    <strong className={styles.title}>{t('install-prompt.title')}</strong>
                    <span className={styles.description}>{t('install-prompt.description')}</span>
                </div>
                <div className={styles.actions}>
                    <Button
                        label={t('install-prompt.dismiss-button')}
                        mode={ButtonMode.primary}
                        outline={true}
                        onClick={dismissPrompt}
                    />
                    <Button
                        label={t('install-prompt.install-button')}
                        mode={ButtonMode.primary}
                        onClick={handleInstall}
                    />
                </div>
            </div>
        </div>
    );
};
